import LabelledTextField from './LabelledTextField';

export { TextField } from './LabelledTextField';
export default LabelledTextField;
